import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { claimActions } from '../../redux/actions'
import claimSteps from '../../../shared/claimSteps.json'
import FormattedMessage from '../FormattedMessage/FormattedMessage'
import NoContentSelectedModal from '../Modal/NoContentSelectedModal/NoContentSelectedModal'
import SurveyNotCompletedModal from '../Modal/SurveyNotCompletedModal/SurveyNotCompletedModal'
import NoAgreementModal from '../Modal/NoAgreementModal/NoAgreementModal'

import './ClaimNavigation.scss'

class ClaimNavigation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emptyContentError: false,
      confirmError: false,
      minCredits: '',
      isSurveyCompleted: false,
    }
  }

  setMinCredits = minimumSelections => {
    this.setState({
      minCredits: minimumSelections,
    })
  }

  scrollToTop = () => {
    if (typeof window === 'undefined') return

    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    })
  }

  selectedContentEmpty = () => {
    const {
      claim: { selectedContentList },
    } = this.props
    let empty = false
    if (selectedContentList.length) {
      selectedContentList.forEach(list => {
        empty = list.selectedContent.length ? true : false || empty
      })
    }
    return empty
  }

  activePromotionStep = () => {
    const {
      claim: { currentPromotion, activePromotionStepId },
    } = this.props
    return (
      currentPromotion &&
      currentPromotion.promotionSteps &&
      currentPromotion.promotionSteps.find(
        promotionStep => promotionStep.id === activePromotionStepId
      )
    )
  }

  minSelected = () => {
    const activePromotionStep = this.activePromotionStep()
    return (
      activePromotionStep.minimumSelections -
        activePromotionStep.creditsUsed -
        activePromotionStep.currentCreditsUsed >
      0
    )
  }

  nextStateHandler = () => {
    const {
      goNextClaimState,
      setActivePromotionStep,
      claim: { claimStep, confirm, survey, currentPromotion, activePromotionStepId },
    } = this.props

    if (claimStep === claimSteps.CONFIRM_REWARD) {
      if (!confirm) {
        this.toggleConfirmError()
      } else {
        goNextClaimState()
        this.scrollToTop()
      }
    } else if (claimStep === claimSteps.ATTEMPT_SURVEY) {
      /* Check if all questions have been responded */

      const pass = survey.map(question => question.finalResponse).every(item => item)

      this.setState({ isSurveyCompleted: pass }, () => {
        if (pass) {
          goNextClaimState()
          this.scrollToTop()
        } else {
          this.toggleSurveyNotCompletedError()
        }
      })
    } else if (claimStep === claimSteps.SELECT_REWARD) {
      if (this.minSelected()) {
        const activePromotionStep = this.activePromotionStep()
        this.setMinCredits(activePromotionStep.minimumSelections)
        this.toggleEmptyContentError()
      } else {
        // Find current promotion index
        const index = currentPromotion.promotionSteps.findIndex(
          temp => temp.id === activePromotionStepId
        )
        // Get next promotion step index
        const nextIndex = index + 1
        // Check if at end of promotion steps
        if (nextIndex < currentPromotion.promotionSteps.length) {
          setActivePromotionStep(currentPromotion.promotionSteps[nextIndex].id)
          this.scrollToTop()
        } else if (this.selectedContentEmpty()) {
          goNextClaimState()
          this.scrollToTop()
        } else {
          this.toggleEmptyContentError()
        }
      }
    } else {
      goNextClaimState()
      this.scrollToTop()
    }
  }

  previousStateHandler = () => {
    const {
      setActivePromotionStep,
      goPreviousClaimState,
      claim: { claimStep, currentPromotion, activePromotionStepId },
    } = this.props

    if (claimStep === claimSteps.SELECT_REWARD) {
      // Find current promotion index
      const index = currentPromotion.promotionSteps.findIndex(
        temp => temp.id === activePromotionStepId
      )
      // Get next promotion step index
      const nextIndex = index - 1
      // Check if at end of promotion steps
      if (nextIndex >= 0) {
        setActivePromotionStep(currentPromotion.promotionSteps[nextIndex].id)
        this.scrollToTop()
      } else {
        goPreviousClaimState()
        this.scrollToTop()
      }
    } else {
      goPreviousClaimState()
      this.scrollToTop()
    }
  }

  toggleEmptyContentError = () => {
    this.setState(prevState => ({
      emptyContentError: !prevState.emptyContentError,
    }))
  }

  toggleConfirmError = () => {
    this.setState(prevState => ({
      confirmError: !prevState.confirmError,
    }))
  }

  toggleSurveyNotCompletedError = () => {
    this.setState(prevState => ({
      isSurveyCompleted: !prevState.isSurveyCompleted,
    }))
  }

  backButtonLogic = () => {
    const {
      claim: { claimStep },
      previousButton,
    } = this.props
    if (previousButton) {
      return claimStep === claimSteps.SELECT_REWARD
    }
    return claimStep === claimSteps.ATTEMPT_SURVEY
  }

  render() {
    const backButtonEnabled = this.backButtonLogic()
    const { isSurveyCompleted, minCredits, emptyContentError, confirmError } = this.state

    return (
      <div className="row claim-navigation" role="navigation" aria-label="Claim process navigation">
        <NoContentSelectedModal
          message={minCredits}
          isOpen={emptyContentError}
          toggle={this.toggleEmptyContentError}
        />
        <NoAgreementModal isOpen={confirmError} toggle={this.toggleConfirmError} />
        <SurveyNotCompletedModal
          isOpen={isSurveyCompleted}
          toggle={this.toggleSurveyNotCompletedError}
        />
        <div className="col">
          <Button
            onClick={this.previousStateHandler}
            type="submit"
            outline
            color="dark"
            block
            disabled={backButtonEnabled}
            name="claimNavigationSubmitBtn"
            aria-label="Go to previous step"
            aria-disabled={backButtonEnabled}
          >
            <i className="fas fa-arrow-left fa-xs" aria-hidden="true" />
            &nbsp;&nbsp;
            <FormattedMessage id="global.label.back" />
          </Button>
        </div>
        <div className="col">
          <Button
            onClick={this.nextStateHandler}
            type="submit"
            outline
            color="dark"
            block
            aria-label="Go to next step"
          >
            <FormattedMessage id="global.label.next" />
            &nbsp;&nbsp;
            <i className="fas fa-arrow-right fa-xs" aria-hidden="true" />
          </Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  claim: state.claimReducers,
  previousButton: state.claimReducers.previousButton,
})

const mapDispatchToProps = dispatch => ({
  goPreviousClaimState: () => dispatch(claimActions.goPreviousClaimState()),
  goNextClaimState: () => dispatch(claimActions.goNextClaimState()),
  setActivePromotionStep: (...args) => dispatch(claimActions.setActivePromotionStep(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ClaimNavigation)
